import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=6fb047d5&"
import script from "./Template.vue?vue&type=script&lang=js&"
export * from "./Template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kusanagi/adop-line-ec_plaisir/b2b/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb047d5')) {
      api.createRecord('6fb047d5', component.options)
    } else {
      api.reload('6fb047d5', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=6fb047d5&", function () {
      api.rerender('6fb047d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Template.vue"
export default component.exports